import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 89px;
    height: 25px;
    left: 0px;
    top: 120px;
    font-size: 14px;
    line-height: 17px;
    /* Green/500 */

    background: ${theme?.colour?.primary};;
    border-radius: 0px 20px 20px 0px;
    color: #FFFFFF;

    @media only screen and (min-width: 768px) {
      top: 26px;
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template });